import styled from 'styled-components';

export const ActionBarRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  margin-top: 16px;
  flex-wrap: wrap;
`;

export const ChipsGroup = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  flex-wrap: wrap;
`;

export const ButtonsGroup = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 10px;
  flex: 1;
  min-width: 0;

  & > button {
    flex-shrink: 0;
    white-space: nowrap;
  }
`;

export const SearchInputWrap = styled.div`
  flex: 1;
  min-width: 120px;
  max-width: 257px;
`;

export const SearchInputWrapper = styled.div`
  display: flex;
  height: 36px;
  padding: 4px 16px;
  align-items: center;
  gap: 4px;
  align-self: stretch;
  background: ${(props) => props.theme.colors?.white ?? '#FFFFFF'};
  border: 1px solid ${(props) => props.theme.colors?.border ?? props.theme.colors?.highClearGray ?? '#D1D5DB'};
  border-radius: 8px;
  transition: border-color 0.2s ease;
  box-sizing: border-box;

  &:focus-within {
    border-color: ${(props) => props.theme.colors?.primary ?? props.theme.colors?.activeBlue ?? '#2563EB'};
    outline: none;
  }
`;

export const SearchIconLeft = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  color: ${(props) => props.theme.colors?.textSecondary ?? props.theme.colors?.davysGrey ?? '#6B7280'};
`;

export const SearchInputWithClearWrap = styled.div`
  flex: 1;
  min-width: 0;
  position: relative;
  display: flex;
  align-items: center;
  height: 100%;
`;

export const SearchInputField = styled.input`
  width: 100%;
  height: 100%;
  border: none;
  background: transparent;
  padding: 0 28px 0 0;
  font-size: 14px;
  line-height: 20px;
  color: ${(props) => props.theme.colors?.text ?? props.theme.colors?.darkGray ?? '#111827'};
  box-sizing: border-box;

  &::placeholder {
    color: ${(props) => props.theme.colors?.textSecondary ?? props.theme.colors?.davysGrey ?? '#9CA3AF'};
  }

  &:focus {
    outline: none;
  }
`;

export const SearchClearButton = styled.button`
  position: absolute;
  right: 0;
  top: 50%;
  transform: translateY(-50%);
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 20px;
  height: 20px;
  padding: 0;
  margin: 0;
  border: none;
  background: transparent;
  border-radius: 50%;
  color: ${(props) => props.theme.colors?.textSecondary ?? props.theme.colors?.davysGrey ?? '#6B7280'};
  cursor: pointer;
  transition: color 0.15s ease, background-color 0.15s ease;

  &:hover {
    color: ${(props) => props.theme.colors?.text ?? props.theme.colors?.darkGray ?? '#111827'};
    background-color: ${(props) => props.theme.colors?.border ?? props.theme.colors?.highClearGray ?? '#E5E7EB'};
  }

  &:focus {
    outline: none;
  }
`;
